
import { defineComponent } from "vue";
// import { ref, watch } from "vue";

export default defineComponent({
  name: "scoreDisplay",
  props: ["score"],
});
